import { useEffect, useState } from "react";
import { useAuthData } from "./contexts";
import { useAuthAction, useInitLoadAction, useSocket } from "./hooks";
import RootRoutes from "./routes/RootRoutes";
import { socket, SOCKET_EVENT } from "./services/Socket";
import { useRecoilState, useRecoilValue } from "recoil";
import { NewThreadMessagesAtom, SelectedMessageThreadAtom } from "./atoms";
import { Message, MessageThread } from "./apis";
import { cPath } from "./config";
import { AppLoader } from "./components";

function App() {
    const { isAuthenticated, user, grant } = useAuthData();
    const { reloadUserAction } = useAuthAction();
    const {
        loadSchoolAndCompanyAction,
        loadMessageIdsAction,
        loadNewMessageThreadsAction,
    } = useInitLoadAction();
    const { userNotificationJoin, userNotificationLeave } = useSocket();
    const [newThreadMessages, setNewThreadMessages] = useRecoilState(
        NewThreadMessagesAtom
    );
    const selectedMessageThread = useRecoilValue(SelectedMessageThreadAtom);

    const [isLoading, setIsLoading] = useState(false);
    const isMessagePage =
        window.location.pathname === cPath("ADMIN.MESSAGES_PAGE");

    useEffect(() => {
        if (isAuthenticated) {
            setIsLoading(true);
            reloadUserAction().finally(async () => {
                // if (UTIL.isSchoolCompanyMultiSelect(user?.userType)) {
                //     loadSchoolAndCompanyAction();
                // }
                await loadSchoolAndCompanyAction();
                setIsLoading(false);
                loadMessageIdsAction();
                if (user && !grant.isSuperAdmin) {
                    loadNewMessageThreadsAction();
                    userNotificationJoin(`user_notification:${user.id}`);
                }
            });
        }
        return () => {
            if (user && !grant.isSuperAdmin) {
                userNotificationLeave(`user_notification:${user.id}`);
            }
        };
    }, [isAuthenticated]);

    useEffect(() => {
        if (isAuthenticated) {
            if (user && !grant.isSuperAdmin) {
                socket.on(
                    SOCKET_EVENT.ON.USER_NOTIFICATION_RECEIVE,
                    (msg: Message) => {
                        const isExist = newThreadMessages.includes(
                            (msg?.messageThread as MessageThread)?.id
                        );
                        if (!isExist) {
                            if (
                                !isMessagePage ||
                                selectedMessageThread !==
                                    (msg?.messageThread as MessageThread)?.id
                            ) {
                                setNewThreadMessages([
                                    ...newThreadMessages,
                                    (msg?.messageThread as MessageThread)?.id,
                                ]);
                            }
                        }
                    }
                );
            }
        }
        return () => {
            if (user && !grant.isSuperAdmin) {
                socket.off(SOCKET_EVENT.ON.USER_NOTIFICATION_RECEIVE);
            }
        };
    }, [isAuthenticated, newThreadMessages, isMessagePage]);

    if (isLoading) {
        return <AppLoader />;
    }

    return <RootRoutes />;
}

export default App;
